export default "__VITE_ASSET__D3suS2gN__"